var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 273,
    viewBox: "0 0 430 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 58.7502,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 0 58.7502)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3245,
    y: 35.4258,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 23.3245 35.4258)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6489,
    y: 12.1013,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 46.6489 12.1013)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3243,
    y: 82.0747,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 23.3243 82.0747)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6489,
    y: 58.7501,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 46.6489 58.7501)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9733,
    y: 35.4256,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 69.9733 35.4256)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2974,
    y: 12.1016,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 93.2974 12.1016)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6487,
    y: 105.399,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 46.6487 105.399)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9732,
    y: 82.0747,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 69.9732 82.0747)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2977,
    y: 58.7501,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 93.2977 58.7501)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 116.622,
    y: 35.426,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 116.622 35.426)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 139.946,
    y: 12.1015,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 139.946 12.1015)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9731,
    y: 128.723,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 69.9731 128.723)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2976,
    y: 105.399,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 93.2976 105.399)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 116.622,
    y: 82.0744,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 116.622 82.0744)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 139.946,
    y: 58.7502,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 139.946 58.7502)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 163.271,
    y: 35.4258,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 163.271 35.4258)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 186.595,
    y: 12.1014,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 186.595 12.1014)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2975,
    y: 152.048,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 93.2975 152.048)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 116.622,
    y: 128.723,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 116.622 128.723)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 139.946,
    y: 105.399,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 139.946 105.399)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 163.27,
    y: 82.0748,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 163.27 82.0748)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 186.595,
    y: 58.7503,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 186.595 58.7503)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 209.919,
    y: 35.4258,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 209.919 35.4258)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 233.244,
    y: 12.1013,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 233.244 12.1013)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 116.622,
    y: 175.372,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 116.622 175.372)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 139.946,
    y: 152.048,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 139.946 152.048)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 163.271,
    y: 128.723,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 163.271 128.723)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 186.595,
    y: 105.399,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 186.595 105.399)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 209.919,
    y: 82.0746,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 209.919 82.0746)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 233.244,
    y: 58.7501,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 233.244 58.7501)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 256.568,
    y: 35.4257,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 256.568 35.4257)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 279.893,
    y: 12.1011,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 279.893 12.1011)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 139.946,
    y: 198.696,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 139.946 198.696)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 162.442,
    y: 221.192,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 162.442 221.192)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 184.937,
    y: 243.687,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 184.937 243.687)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 207.433,
    y: 266.183,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 207.433 266.183)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 163.271,
    y: 175.372,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 163.271 175.372)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 185.766,
    y: 197.868,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 185.766 197.868)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 208.262,
    y: 220.363,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 208.262 220.363)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 230.757,
    y: 242.858,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 230.757 242.858)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 186.595,
    y: 152.047,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 186.595 152.047)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 209.091,
    y: 174.543,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 209.091 174.543)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 231.586,
    y: 197.039,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 231.586 197.039)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 254.082,
    y: 219.534,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 254.082 219.534)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 209.919,
    y: 128.723,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 209.919 128.723)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 232.415,
    y: 151.219,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 232.415 151.219)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 254.91,
    y: 173.714,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 254.91 173.714)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 277.406,
    y: 196.21,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 277.406 196.21)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 233.244,
    y: 105.399,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 233.244 105.399)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 255.739,
    y: 127.895,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 255.739 127.895)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 278.235,
    y: 150.39,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 278.235 150.39)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 300.73,
    y: 172.885,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 300.73 172.885)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 256.568,
    y: 82.0744,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 256.568 82.0744)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 279.064,
    y: 104.57,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 279.064 104.57)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 301.559,
    y: 127.066,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 301.559 127.066)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 324.055,
    y: 149.561,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 324.055 149.561)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 279.893,
    y: 58.7499,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 279.893 58.7499)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 302.388,
    y: 81.2455,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 302.388 81.2455)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 324.884,
    y: 103.741,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 324.884 103.741)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 347.379,
    y: 126.237,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 347.379 126.237)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 303.217,
    y: 35.4256,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 303.217 35.4256)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 325.713,
    y: 57.9211,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 325.713 57.9211)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 348.208,
    y: 80.4165,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 348.208 80.4165)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 370.704,
    y: 102.912,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 370.704 102.912)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 326.541,
    y: 12.1015,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 326.541 12.1015)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 349.037,
    y: 34.5969,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 349.037 34.5969)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 371.532,
    y: 57.0925,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 371.532 57.0925)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 394.028,
    y: 79.588,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 394.028 79.588)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 372.361,
    y: 11.2729,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 372.361 11.2729)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 394.856,
    y: 33.7684,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 394.856 33.7684)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 417.352,
    y: 56.2639,
    width: 8.24641,
    height: 8.24641,
    rx: 1.34409,
    transform: "rotate(-45 417.352 56.2639)",
    fill: "#3672B9",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1);
export default __webpack_public_path__ + "static/media/Pattern1.6651ff40ba5c01531a5daed9b6864729.svg";
export { ForwardRef as ReactComponent };